import { MapPin, BedDouble, Sparkles, UtensilsCrossed, Star, Award, CalendarDays } from "lucide-react";
import { Section, SectionHead } from "@/components/landing/Section";
import { BudgetBar } from "@/components/BudgetBar";
import { TransportCompare } from "@/components/TransportCompare";
import { imageFor } from "@/lib/api";

const EX = {
  budget: { transport: 26, accommodation: 130, food: 110, activities: 60, total: 326 },
  transport: { recommended: "train", cheapest: "train", fastest: "train",
    train: { available: true, duration: "50 min", price: 26 }, car: { duration: "1h00", price: 30 } },
};

const Line = ({ icon: Icon, label, value, sub }) => (
  <div className="flex gap-3">
    <Icon className="w-4 h-4 mt-0.5 text-amber-600 shrink-0" />
    <div><p className="text-[11px] font-mono uppercase tracking-widest text-gray-400">{label}</p><p className="text-sm font-medium text-gray-900">{value}</p>{sub ? <p className="text-xs text-gray-500">{sub}</p> : null}</div>
  </div>
);

export const ExampleResult = () => (
  <Section id="exemples">
    <div className="grid lg:grid-cols-[1fr_1.15fr] gap-12 items-center">
      <SectionHead eyebrow="Exemple de résultat" title="Une vraie escapade, pas une idée vague">
        Au départ de Bordeaux, 2 jours, 2 voyageurs, 350 € de budget. Voici l'une des trois propositions reçues : budget détaillé, transport comparé, et tout regroupé autour du Bassin.
      </SectionHead>
      <article data-testid="example-result-card" className="rounded-2xl bg-white border border-gray-200 overflow-hidden shadow-xl">
        <div className="relative h-44">
          <img src={imageFor({ title: "Dune du Pilat et plage", destination: "Arcachon" })} alt="Arcachon" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B131E]/85 to-transparent" />
          <span data-testid="example-best-value-badge" className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-emerald-600 text-white text-[11px] font-semibold"><Award className="w-3.5 h-3.5" />Meilleur rapport budget / plaisir</span>
          <div className="absolute bottom-3 left-5 right-5 text-white">
            <p className="flex items-center gap-3 text-xs text-gray-200"><span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />Arcachon · 65 km</span><span className="flex items-center gap-1"><CalendarDays className="w-3.5 h-3.5" />2 jours</span></p>
            <h3 className="font-serif text-2xl font-semibold">Arcachon & Dune du Pilat</h3>
          </div>
        </div>
        <div className="p-6 grid sm:grid-cols-2 gap-6">
          <div className="space-y-5"><BudgetBar budget={EX.budget} userBudget={350} compact testid="example-budget" /><TransportCompare transport={EX.transport} testid="example-transport" /></div>
          <div className="space-y-4">
            <Line icon={BedDouble} label="Hôtel" value="Hôtel 2* centre-ville" sub={<span className="inline-flex items-center gap-1">Proche plage · <Star className="w-3 h-3 fill-amber-500 text-amber-500" />4.3</span>} />
            <Line icon={Sparkles} label="Activité" value="Dune du Pilat & forêt" sub="Gratuit" />
            <Line icon={UtensilsCrossed} label="Restaurant" value="Cabane ostréicole du port" sub="Fruits de mer · €€" />
            <p className="text-xs text-emerald-800 bg-emerald-50 rounded-lg p-3">Tout dans un rayon de 5 km : à pied ou en bus local.</p>
          </div>
        </div>
      </article>
    </div>
  </Section>
);
